import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import RichTextDisplayWithMessageContextMenu from 'Components/UI/RichTextDisplayWithMessageContextMenu';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

const RichTextDisplayPicker = ({
  resource,
  content,
}) => {
  return pick(resource, {
    [fr.relationships.messagesRightClickMenu.name]: <RichTextDisplayWithMessageContextMenu content={content} />,
  }, <RichTextDisplay content={content} />);
};

export default RichTextDisplayPicker;
